// @ts-expect-error TODO(typecheck-unify): TS6133 'React' is declared but its value is never read.
import React, { useEffect, useState } from "react";

import { fetchHcfDetails } from "./api";
import { ShowError } from "../../../components/error";
import { Title } from "./title";
import { Value } from "./value";
import { Stack } from "@mui/material";
import { showErrorToast } from "@src/appV2/lib/Notifications";
import { handleApiError } from "src/utils/errors";

// @ts-expect-error TODO(typecheck-unify): TS7031 Binding element 'hcfId' implicitly has an 'any' type.
function DisputeTerms({ hcfId, updateFacility }) {
  // FIXME: Automatically disabled during ESLint config update
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [details, setDetails] = useState<any>();
  const [error, setError] = useState();

  useEffect(() => {
    fetchHcfDetails(hcfId, "disputeTerms").then(setDetails).catch(setError);
  }, [hcfId]);

  // @ts-expect-error TODO(typecheck-unify): TS7006 Parameter 'data' implicitly has an 'any' type.
  const handleChange = (data) => {
    if (data && data?.disputeTerms > 99) {
      showErrorToast("Dispute terms value should not be greater than 99");
    } else {
      updateFacility({
        ...data,
        facilityId: hcfId,
      }).catch(handleApiError);
    }
  };

  return (
    <Stack>
      <Title>Dispute Terms</Title>
      <ShowError error={error} message="Unable to fetch workplace Dispute Terms" />
      <p className="content">
        This workplace has
        <Value name="disputeTerms" onChange={handleChange} value={details?.disputeTerms} />
        days from receipt of a Clipboard invoice to dispute the invoice contents
      </p>
    </Stack>
  );
}

export { DisputeTerms };
